import React from 'react'

const TechnologyHeaderIcon = ({ className, size = 32 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="tech-grad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(33, 150, 243, 1)" />
          <stop offset="100%" stopColor="rgba(25, 118, 210, 1)" />
        </linearGradient>
        <filter id="tech-glow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Circuit board */}
      <rect x="6" y="8" width="20" height="16" rx="2" stroke="url(#tech-grad)" strokeWidth="2" filter="url(#tech-glow)"/>
      
      {/* Central processor */}
      <rect x="12" y="13" width="8" height="6" rx="1" fill="url(#tech-grad)" opacity="0.8"/>
      
      {/* Circuit paths */}
      <path d="M12 16H8M20 16H24" stroke="url(#tech-grad)" strokeWidth="2" strokeLinecap="round"/>
      <path d="M16 13V10M16 19V22" stroke="url(#tech-grad)" strokeWidth="2" strokeLinecap="round"/>
      
      {/* Connection nodes */}
      <circle cx="8" cy="16" r="1.5" fill="url(#tech-grad)"/>
      <circle cx="24" cy="16" r="1.5" fill="url(#tech-grad)"/>
      <circle cx="16" cy="10" r="1.5" fill="url(#tech-grad)"/>
      <circle cx="16" cy="22" r="1.5" fill="url(#tech-grad)"/>
      
      {/* Small chips */}
      <rect x="8" y="11" width="2" height="2" rx="0.5" fill="url(#tech-grad)" opacity="0.6"/>
      <rect x="22" y="11" width="2" height="2" rx="0.5" fill="url(#tech-grad)" opacity="0.6"/>
      <rect x="8" y="19" width="2" height="2" rx="0.5" fill="url(#tech-grad)" opacity="0.6"/>
      <rect x="22" y="19" width="2" height="2" rx="0.5" fill="url(#tech-grad)" opacity="0.6"/>
      
      {/* Energy waves */}
      <path d="M2 12C3 10 5 8 8 8" stroke="url(#tech-grad)" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
      <path d="M30 12C29 10 27 8 24 8" stroke="url(#tech-grad)" strokeWidth="1.5" strokeLinecap="round" opacity="0.4"/>
      
      {/* Binary code */}
      <circle cx="3" cy="16" r="0.8" fill="url(#tech-grad)" opacity="0.5"/>
      <circle cx="29" cy="16" r="0.8" fill="url(#tech-grad)" opacity="0.5"/>
    </svg>
  )
}

export default TechnologyHeaderIcon
